import {newE2EPage, E2EPage, E2EElement} from '@stencil/core/testing';

describe('counter e2e', () => {
    it('should display default HTML5 errors if the component value is not valid, according to given min/max', async () => {
        const page: E2EPage = await newE2EPage();
        await page.setContent('<joy-counter min="10" max="500"></joy-counter>');
        const input: E2EElement = await page.find('joy-counter input');

        /**
         * In an actual browser, we don't need to delete the default 0 value of the input number, because typing a first number will overwrite it.
         * Here for unknown reason, it does not reset it, so we do it programmatically
         */
        await input.focus();
        await input.press('Backspace');

        await input.press('Digit4');
        await input.press('Digit3');
        await input.press('Digit2');
        await input.press('Digit1');

        await page.$eval('input', (e: Element) => {
            (e as HTMLInputElement).blur();
        });

        await page.waitForChanges();
        const error = await page.find('joy-counter joy-form-error');
        expect(error).not.toBe(null);

        const message = error.getAttribute('no-html-error-text');
        expect(error).not.toBe(null);
        expect(message).not.toBe(null);
    });
});
